import {colors, sizes} from "../../../utils/styled/_variables.styled";
import Icon from "../../Icon/Icon";
import Link from "../../Link/Link";
import {InfiosContentTeaserList} from "./ContentTeaserList.style";
import sanitizeHtml from "sanitize-html";
import sanitizeWhiteList from "../../sanitize-html.whitelist";
import {urlHasParam} from "../../../utils/js/params";
import {useEffect, useState} from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";


export default function ContentTeaserList(props) {
    const {
        className,
        title,
        description,
        linkText,
        linkPath,
        image,
        imageCrop,
        alt,
        imageTitle,
        date,
        author,
        contentType,
        readingTime,
        shadow,
        term,
        fullWidth
    } = props;

    const highlightTerm = (text) => {
        if (text && term) {
            const regex = new RegExp(term, "gi");
            return text.replace(regex, (match) => `<b style="font-weight: bold">${match}</b>`);
        } else {
            return text;
        }
    };

    const [deviceType, setDeviceType] = useState('');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            // Adjust these values based on your desired breakpoints
            const isMobile = width <= sizes.mobile;
            const isTablet = width > sizes.mobile && width <= sizes.tabletLarge;
            const isDesktop = width > sizes.tabletLarge;

            if (isMobile) {
                setDeviceType('mobile');
            } else if (isTablet) {
                setDeviceType('tablet');
            } else if (isDesktop) {
                setDeviceType('desktop');
            }
        };

        // Initial check on component mount
        handleResize();

        // Listen for window resize events
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <InfiosContentTeaserList className={className} fullWidth={fullWidth} shadow={shadow}>
            <div className="content__list">
                {image && <div className="content__list__wrapper">
                    <LazyLoadImage className="content__list__wrapper_image" src={imageCrop.newsDesktop} alt={alt}
                         title={imageTitle}/>
                </div>}
                <div className="content__list_container">
                    <div className="content__list_container_info">
                        {(contentType == "News" || contentType == "Articles") &&
                            <p className="label-small">
                                {date}
                                {date && author && <span className="separator"></span>}
                                {author}
                                {(date || author) && readingTime && <span className="separator"></span>}
                                {readingTime &&
                                    <Icon className="content__list_icon" icon="eye-filled" color={colors.gray4}/>}
                                {readingTime && `${readingTime} min`}
                            </p>}
                        {(contentType != "News" && contentType != "Articles") &&
                            contentType &&
                            <p className="label-small">
                                <span className="content__list_type">{contentType}</span>
                                {readingTime && <>
                                    <span className="separator"></span>

                                    <Icon className="content__list_icon" icon="eye-filled" color={colors.gray4}/>
                                {readingTime} min
                                </>}
                            </p>}
                    </div>
                    <div className="content__list_container_texts">
                        <p className="heading-5 content__list_title">{title}</p>
                        {description?.length > 0 && <p className="label-medium content__list_text"
                                                                     dangerouslySetInnerHTML={{__html: sanitizeHtml(highlightTerm(description), sanitizeWhiteList)}}></p>}
                        <Link
                            className={`content__list_link ${description?.length > 0 ? "" : "margin"}`}
                            animated
                            link={`${linkPath}${urlHasParam('wcmmode=disabled') ? '?wcmmode=disabled' : ''}`}
                            text={linkText}/>
                    </div>
                </div>
            </div>
        </InfiosContentTeaserList>
    );
}
